import { Component, OnInit, ViewChild } from "@angular/core";
import * as FileSaver from "file-saver";
import { NgxSpinnerService } from "ngx-spinner";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { Condition } from "src/app/models/custom-types";
import { RecepcionDTO } from "src/app/models/dto/entregas.dto";
import { FilterEvent } from "src/app/models/filter";
import { ListAction } from "src/app/models/list-actions.model";
import { ListColumn } from "src/app/models/list-columns.model";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { Filter } from "src/app/shared/classes/filter";
import Swal from "sweetalert2";
import { LayoutsService } from "../../../services/layouts.service";
import { PermisosService } from "../../../services/permisos.service";
import { RecepcionForm } from "./form/form.component";
import { RecepcionService } from "./recepcion.service";

import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import * as dayjs from "dayjs";

dayjs.extend(utc);
dayjs.extend(timezone);

@Component({
  selector: "app-recepcion",
  templateUrl: "./recepcion.component.html",
  styles: [],
})
export class RecepcionComponent implements OnInit {
  public columns: ListColumn[] = [
    {
      name: "Folio",
      property: "Folio",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Chofer",
      property: "Chofer",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Supervisor",
      property: "Supervisor",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Unidad",
      property: "Unidad",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Fecha",
      property: "FechaStr",
      visible: true,
      isModelProperty: true,
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
      isModelProperty: false,
    },
  ];

  public actions: ListAction<any>[] = [
    {
      desc: "Descargar PDF",
      action: "download",
      visible: () => true,
    },
  ];

  realdata: RecepcionDTO[];

  @ViewChild(CardTableComponent, { static: true })
  public tableComp: CardTableComponent;

  @ViewChild(RecepcionForm, { static: true })
  public formulario: RecepcionForm;

  constructor(
    public service: RecepcionService,
    public layoutServ: LayoutsService,
    public spinner: NgxSpinnerService,
    public permisoServ: PermisosService,
    public alerts: AlertasSwalService,
  ) {
    this.layoutServ.changeHeader("Recepcion de unidades");
  }

  ngOnInit(): void {
    this.loadRecords();
    this.filter = new Filter<RecepcionDTO>(this.conditions, this.columns, true);

    var permisos = this.permisoServ.getPermisos();
    if (permisos.includes("spcl_recp_edit")) {
      this.actions = [
        ...this.actions,
        {
          desc: "Actualizar",
          action: "update",
          visible: () => true,
        },
      ];
    }
    if (permisos.includes("spcl_recp_remove")) {
      this.actions = [
        ...this.actions,
        {
          desc: "Eliminar",
          action: "remove",
          visible: (row) => true,
        },
      ];
    }
  }
  loadRecords() {
    this.service.get().subscribe(
      (resultData) => {
        this.realdata = resultData.map((m) => {
          const date = dayjs.utc(m.Fecha);

          // Convert to GMT -8 (Pacific Time)
          const gmt8Date = date.tz("America/Los_Angeles");
          const fechaTransform = m.Fecha ? gmt8Date : null;
          return {
            ...m,
            FechaStr: fechaTransform
              ? fechaTransform.format("DD/MM/YYYY hh:mm a")
              : "",
          };
        });
        this.filter.setDataTable(this.realdata, this.tableComp);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
    );
  }

  //#region Filter
  public filter: Filter<RecepcionDTO>;
  public conditions: Condition<RecepcionDTO> = {
    Chofer: (o, f) => o.Chofer.toLocaleLowerCase().indexOf(f) > -1,
    Supervisor: (o, f) => o.Supervisor.toLocaleLowerCase().indexOf(f) > -1,
    Unidad: (o, f) => o.Unidad.toLocaleLowerCase().indexOf(f) > -1,
    Folio: (o, f) =>
      (o.Folio ?? "").toString().toLocaleLowerCase().indexOf(f) > -1,
  };

  filterdata(e: FilterEvent) {
    this.filter.filterdata(e, this.realdata, this.tableComp);
  }
  //#endregion Filter
  saveForm(e: { mode: string; value: any }) {
    if (e.mode == "create") {
      this.guardar(e.value);
    } else if (e.mode == "update") {
      this.actualizar(e.value);
    }
  }
  actionstable(e: { action: string; row: any }) {
    if (e.action == "update") {
      this.formulario.setUpdate(e.row);
    } else if (e.action == "activate") {
      this.activar(e.row);
    } else if (e.action == "download") {
      this.downLoad(e.row.IdRecepcion, e.row.Folio);
    } else {
      Swal.fire({
        title: "Seguro que quieres eliminar este registro?",
        text: "Esta accion es irreversible!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          this.eliminar(e.row);
        }
      });
    }
  }

  guardar(row: any) {}
  actualizar(row: any) {}
  eliminar(row: any) {}
  activar(row: any) {}
  downLoad(e, folio) {
    this.spinner.show();
    this.service.getPdf(e).subscribe(
      (response) => {
        const contentType = response.headers.get("content-type");
        this.downLoadFile(
          response.body,
          contentType,
          "rececepcion_" + folio + ".pdf",
        );
      },
      (err) => {
        this.spinner.hide();
        this.alerts.error("Error", "Ocurrio un error");
      },
    );
  }

  downLoadFile(data: any, contentType: string, filename: string) {
    let blob = new Blob([data], { type: contentType });
    FileSaver.saveAs(blob, filename);
    this.spinner.hide();
  }
}
